import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-sowhatbuy-features-slider.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';

const SLIDE_IMAGE_1 =
  'https://cdn.skyfastimg.com/images/2026/07/02/image-6a45cddc678d02b772fb2fcf.png?w=1000&h=50&q=80';
const SLIDE_IMAGE_2 =
  'https://cdn.skyfastimg.com/images/2026/07/02/image-6a45cdf1e72a5fefe64856d4.png?w=1000&h=50&q=80';
const SLIDE_IMAGE_3 =
  'https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ce00f4d9616e5a287c72.png?w=1000&h=50&q=80';
const SLIDE_IMAGE_4 =
  'https://cdn.skyfastimg.com/images/2026/07/02/image-6a45ce149cbdc47c17e16aea.png?w=1000&h=50&q=80';

const ARROW_RIGHT_ICON =
  'https://cdn.skyfastimg.com/images/2026/07/02/image-6a45d35b3a84d93f1fcfdd15.png?w=500&h=50&q=80';

const buttonPrimaryHtml = buttonPrimary({
  text: 'BUY NOW GET 50% OFF',
  backgroundColor: '#C75023',
  radius: 8,
  iconPrefix: {
    show: false,
  },
  iconSuffix: {
    show: true,
    src: ARROW_RIGHT_ICON,
  },
  subBtn: {
    show: false,
    text: '',
  },
});

const defaultItems = [
  {
    tabLabel: 'Battery Indicator',
    image: SLIDE_IMAGE_1,
    title: 'Smart Battery Indicator',
    description: 'No more frequent battery changes — rechargeable & energy-saving.',
  },
  {
    tabLabel: 'Foldable Design',
    image: SLIDE_IMAGE_2,
    title: 'Fast Charging,Long-Lasting Power.',
    description: 'No frequent battery changes needed',
  },
  {
    tabLabel: 'Strong Toughness',
    image: SLIDE_IMAGE_3,
    title: 'High-Toughness, Shatter-Resistant Design',
    description: 'Wear & drop resistant, easy reading for seniors.',
  },
  {
    tabLabel: 'Fast Charge',
    image: SLIDE_IMAGE_4,
    title: 'Foldable Design For Easy Storage',
    description: 'portable and space-saving,use anytime, anywhere.',
  },
];

const renderTab = (item, index) => `
  <button
    type="button"
    class="sowhatbuy-features-slider__tab${index === 0 ? ' active' : ''}"
    data-attribute="sowhatbuy-features-slider__tab"
    data-index="${index}"
    data-active="${index === 0 ? 'true' : 'false'}"
  >${item.tabLabel}</button>
`;

const renderSlide = item => `
  <div class="swiper-slide" data-attribute="sowhatbuy-features-slider__slide">
    <div class="sowhatbuy-features-slider__card" data-attribute="sowhatbuy-features-slider__card">
      <div class="sowhatbuy-features-slider__card-image-wrap">
        <img
          loading="lazy"
          data-attribute="sowhatbuy-features-slider__card-image"
          src="${item.image}"
          alt=""
        />
      </div>
      <div class="sowhatbuy-features-slider__card-body">
        <div
          class="sowhatbuy-features-slider__card-title"
          data-attribute="sowhatbuy-features-slider__card-title"
        >${item.title}</div>
        <div
          class="sowhatbuy-features-slider__card-description"
          data-attribute="sowhatbuy-features-slider__card-description"
        >${item.description}</div>
      </div>
    </div>
  </div>
`;

const contentHtml = `
  <div
    class="sowhatbuy-features-slider"
    data-attribute="sowhatbuy-features-slider-content"
  >
    <div class="sowhatbuy-features-slider__header container" data-attribute="sowhatbuy-features-slider__header">
      <div class="sowhatbuy-features-slider__title" data-attribute="sowhatbuy-features-slider__title">
        <h2>
          <span style="color:#d35400;"><strong>All-In-One</strong></span>
          <strong> Versatility</strong>
        </h2>
        <p>Durable design, reliable companion for your loved ones.</p>
      </div>
      <div class="sowhatbuy-features-slider__tabs" data-attribute="sowhatbuy-features-slider__tabs">
        ${defaultItems.map(renderTab).join('\n')}
      </div>
    </div>
    <div class="sowhatbuy-features-slider__slider-wrap" data-attribute="sowhatbuy-features-slider__slider-wrap">
      <div class="swiper sowhatbuy-features-slider__swiper">
        <div class="swiper-wrapper" data-attribute="sowhatbuy-features-slider__list">
          ${defaultItems.map(renderSlide).join('\n')}
        </div>
      </div>
      ${buttonPrimaryHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#F8FAF5',
  topPadding: true,
  bottomPadding: true,
});
